import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Action } from '@interstate/components/Action';
import { ArrowTopRightOnSquareIcon, PlusIcon } from '@interstate/components/Icons';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';

import { FormContext } from '../formManager/formContext';
import { NoVehicleLinks } from './Style';

/**
 * "Add Vehicle" and "vAuto" links shown in the Vehicle Details flyout for a deal/quote without a
 * vehicle (US2032152), so the user can add a real vehicle or open vAuto from the inventory-type view.
 *
 * This is only rendered when the deal has no vehicle, so "Add Vehicle" is always shown - matching the
 * card's `isShowVehicleSelection = !hasVehicle || ...` rule where the no-vehicle case is unconditional.
 */
export const NoVehicleActions = () => {
    const dispatch = useDispatch();
    const { hideDrawer } = useContext(FormContext);
    const vAutoUrl = useSelector(configSelectors.getVAutoInventoryUrl);

    return (
        <NoVehicleLinks>
            <Action
                data-testid="btnAddVehicle"
                size="sm"
                onClick={() => {
                    hideDrawer();
                    dispatch(interactionAnalyticsActionCreators.mvChangeVehicle());
                    dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.ChangeVehicle));
                }}
                actionIcon={{ icon: <PlusIcon data-testid="add-vehicle-icon" />, start: true }}
            >
                Add Vehicle
            </Action>
            {vAutoUrl && (
                <Action
                    data-testid="vauto-link"
                    size="sm"
                    disabled={true}
                    actionIcon={{ icon: <ArrowTopRightOnSquareIcon />, start: true }}
                >
                    vAuto
                </Action>
            )}
        </NoVehicleLinks>
    );
};

export default NoVehicleActions;
